import React, { useEffect, useState, useRef } from "react";
import Link from "next/link";
import styled from "styled-components";
import { SmallButton } from "../components/AppButton";
import { useRouter } from "next/router";
import SearchBar from "../components/SearchBar";
import config from "../config/app.json";
import { apiRequest } from "../../pages/api/requestHelper";
import { ContentLoader } from "../components/Loader";
import useCheckIsMobile from "../hooks/useCheckIsMobile";
import Accordion from "../components/Accordion";
import HelloBar from "./HelloBar";

const AppHeader = styled.header`
  position: sticky;
  transition: all .3s linear;
  z-index: 10;
  background: #fff;
  box-shadow: 0px 0px 6px #efefef;
   ${(props) => props.showHelloBar ?
    `
      top: 72px;

      @media (max-width: 797px) {
        top: 113px;
      } 
      @media (max-width: 593px) {
        top: 134px;
      }
      `:
    `top: 0px;`
  }
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 30px;
  content-visibility: auto;
  @media (max-width: 425px) {
    margin: 0px 15px;
  }
`;

const NavBar = styled.nav`
  min-height: 65px;
  margin: 0;
  z-index: 999;
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  padding-left: 0;
  display: flex;
  align-items: center;
  margin: 0 auto;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0px 50px;
  @media (max-width: 425px) {
    padding: 0px;
  }
`;

export const HeaderTag = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    margin-left: 2px;
  }
`;

const CreateTagContainer = styled(HeaderTag)`
  height: 100%;
  margin-right: 20px !important;
  &:hover {
    .create-drop-down {
      display: block;
      position: absolute;
    }
    .create-tag {
      background: #efefef;
      border-radius: 6px;
      @media (max-width: 425px) {
        background: #fff;
      }
    }
  }
  @media (max-width: 425px) {
    height: auto;
  }
`;

const ProductTagContainer = styled(CreateTagContainer)`
  &:hover {
    .product-drop-down {
      display: block;
      position: absolute;
    }
    .product-tag {
      background: #efefef;
      border-radius: 6px;
      @media (max-width: 425px) {
        background: #fff;
      }
    }
  }
  @media (max-width: 425px) {
    height: auto;
  }
`;

const CreateTag = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  @media (max-width: 425px) {
    padding: 0px;
  }
`;

const CreateDropDownContainer = styled.div`
  display: none;
  width: 100%;
  height: 280px;
  background-color: #fff;
  position: fixed;
  padding: 0px 40px;
  top: 65px;
  left: 0;
  box-sizing: border-box;
  box-shadow: 0px 0px 6px 0px #9696961a;
  border-radius: 6px;
  z-index: 10;
  border: 1px solid #eaeaea;

  @media (max-width: 980px) {
    height: 360px;
    top: 0px;
    padding: 0px;
  }

  @media (max-width: 425px) {
    top: 80px;
    padding: 0px 10px;
  }
`;

const ProductDropDownContainer = styled.div`
  display: none;
  width: 50%;
  height: 360px;
  background-color: #fff;
  position: fixed;
  padding: 0px 40px;
  top: 65px;
  right: 100px;
  box-sizing: border-box;
  box-shadow: 0px 0px 6px 0px #9696961a;
  border-radius: 6px;
  z-index: 10;
  border: 1px solid #eaeaea;

  @media (max-width: 980px) {
    height: 360px;
    padding: 0px;
    top: 0px;
    right: 0px;
    width: ${(props) => (props.isHomePage ? "75%" : "100%")};
    ${(props) =>
      props.isHomePage &&
      `
      top: 65px;
      left: 100px;
    `}
  }

  @media (max-width: 425px) {
    top: 90px;
    padding: 0px 10px;
    width: 50%;
    right: 0px;
    left: 130px;
  }
`;

const SocialDropDownContainer = styled.div`
  display: none;
  width: 275px;
  height: 200px;
  background-color: #fff;
  position: fixed;
  padding: 10px 25px;
  top: 65px;
  box-sizing: border-box;
  box-shadow: 0px 0px 6px 0px #9696961a;
  border-radius: 6px;
  z-index: 10;
  border: 1px solid #eaeaea;

  @media (max-width: 980px) {
    height: 360px;
    padding: 0px;
    top: 0px;
    right: 0px;
    width: ${(props) => (props.isHomePage ? "75%" : "100%")};
    ${(props) =>
      props.isHomePage &&
      `
      top: 65px;
      left: 100px;
    `}
  }

  @media (max-width: 425px) {
    top: 90px;
    padding: 0px 10px;
    width: 50%;
    right: 0px;
    left: 130px;
  }
`;

const HeaderTagContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: flex-start;

  @media (max-width: 767px) {
    align-items: flex-start;
    margin-left: 0;
    width: 60%;
    z-index: -1;
  }

  @media (max-width: 425px) {
    position: absolute;
    width: 100%;
    background: #fff;
    display: ${(props) => (props.showSearch ? "block" : "none")};
    z-index: 2;
  }

  > * {
    margin-right: 30px;
  }
`;

const MenuBarContainer = styled.div`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-right: 15px;
  display: none;
  z-index: 1;
  transform-origin: 1px;
  transition: all 0.3s ease-in-out;

  div:first-child {
    transform: ${({ open }) => (open ? "rotate(45deg)" : "rotate(0)")};
    ${({ open }) =>
      open
        ? `position: absolute; transform: rotate(45deg)`
        : `transform: rotate(0)`}
  }

  div:nth-child(2) {
    opacity: ${({ open }) => (open ? "0" : "1")};
    transform: ${({ open }) => (open ? "translateX(20px)" : "translateX(0)")};
  }

  div:nth-child(3) {
    ${({ open }) =>
      open
        ? `position: absolute; transform: rotate(-45deg)`
        : `transform: rotate(0)`}
  }
  @media screen and (max-width: 425px) {
    display: ${(props) => (props.page === "/templates" ? "none" : "flex")};
  }
`;

const MenuBar = styled.div`
  width: 20px;
  height: 2px;
  background-color: #2d2d2d;
  margin: 2px;
  border-radius: 3px;
`;

const HeaderTagRightContainer = styled.div`
  margin-left: 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 65px;
  a:last-child {
    margin-right: 0;
  }
  > * {
    margin-right: 30px;
    @media (max-width: 425px) {
      margin-right: 10px;
    }
  }

  ${(props) =>
    props.page !== "/" &&
    `@media (max-width: 980px) {
    align-items: flex-start;
    flex-flow: column nowrap;
    position: absolute;
    top: ${props.open ? "60px" : "0px"};
    right: 50px;
    height: auto;
    width: 300px;
    border-radius: 4px;
    background: #fff;
    padding: 20px;
    box-sizing: border-box;
    box-shadow: 6px 0px 5px #2d2d2d1f;
    transform: ${props.open ? "translateY(0)" : "translateY(-100%)"};
    -webkit-transform: ${props.open ? "translateY(0)" : "translateY(-100%)"};
    > div {
      margin: 10px 0px;
      height: unset;
      .create-tag, .product-tag {
        padding: 0px;
      }
    }
    > a {
      width: 100%;
    }
  }`}

  @media (max-width: 425px) {
    align-items: flex-start;
    flex-flow: column nowrap;
    position: absolute;
    top: 0px;
    right: 0px;
    height: 100vh;
    width: 100vw;
    background: #fff;
    padding: 40px 42px;
    box-sizing: border-box;
    ${({ open }) => (open ? "display: flex;" : "display: none;")}
    overflow: scroll;
    > div {
      margin: 10px 0px;
    }
    > a {
      /* margin-top: auto;
      margin-bottom: 15%; */
      width: 100%;
    }
  }
`;

const HeaderTagContent = styled.p`
  font-size: 15px;
  font-family: "Lato";
  margin: 0px;
  color: #2d2d2d;
  text-decoration: none;
  .coming-soon {
    background: #fdc356;
    display: inline-block;
    color: #000;
    position: absolute;
    font-size: 20px;
    font: normal normal bold 8.3px/17px PT Sans;
    right: 0px;
    bottom: 20px;
    border-radius: 20px;
    padding: 0.1px 10px;
  }
`;
export const HeaderLinkTag = styled.a`
  font-size: 15px;
  font-family: "Lato";
  margin: 0px;
  color: #2d2d2d;
  text-decoration: none;
  white-space: nowrap;
  position: relative;

  .coming-soon {
    background: #fdc356;
    display: inline-block;
    color: #000;
    position: absolute;
    font-size: 20px;
    font: normal normal bold 8.3px/17px PT Sans;
    right: 0px;
    bottom: 20px;
    border-radius: 20px;
    padding: 0.1px 10px;
  }
`;

const SearchBarIconContainer = styled.div`
  display: none;
  @media (max-width: 425px) {
    display: flex;
    margin: 0px 10px;
  }
`;

const HeaderResContainer = styled.div`
  display: flex;
`;

const TemplateContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 40px 0px;
  @media (max-width: 425px) {
    margin: 20px 0px;
  }
`;

const TemplateListWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-behavior: smooth;
  align-items: flex-end;
  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

const TemplateWrapper = styled.div`
  display: flex;
  margin-right: 20px;
  width: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const Template = styled.a`
  width: ${(props) => `${props.width}px` || "120px"};
  height: ${(props) => `${props.height}px` || "60px"};
  background-color: ${(props) => props.color || "#ffe6e6"};
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const TemplateTitle = styled.p`
  font-size: 14px;
  margin: 10px 0;
  cursor: auto;
  text-align: center;
  color: #54536c;
  white-space: nowrap;
`;

const TemplateListConatiner = styled.div`
  display: flex;
  position: relative;
  margin-bottom: 40px;
  @media (max-width: 425px) {
    margin-bottom: 20px;
  }
`;

const ListSliderIcon = styled.span`
  position: absolute;
  cursor: pointer;
  z-index: 1;
  width: 50px;
  height: 50px;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
`;

const LeftSliderIcon = styled(ListSliderIcon)`
  background-image: url(${(props) => props.url});
  background-repeat: no-repeat;
  left: -35px;
  display: none;
  @media (max-width: 425px) {
    display: none;
  }
`;

const RightSliderIcon = styled(ListSliderIcon)`
  background-image: url(${(props) => props.url});
  background-repeat: no-repeat;
  right: -35px;
  @media (max-width: 425px) {
    display: none;
  }
`;

const RoundedMenuContainer = styled.div`
  display: none;
  justify-content: center;
  align-items: center;
  padding: 16.5px 10px;
  cursor: pointer;
  ${(props) =>
    props.active &&
    `
  background-color: #efefef;
  border-radius: 6px;
  `}
  &:hover {
    background-color: #efefef;
    border-radius: 6px;
  }
  span:last-child {
    margin-right: 0;
  }

  @media (max-width: 980px) {
    display: flex;
  }
  @media (max-width: 425px) {
    display: none;
  }
`;

const RoundedMenu = styled.span`
  height: 5px;
  width: 5px;
  font-size: 15px;
  border-radius: 10px;
  background: #000;
  margin-right: 2px;
`;

const MidDropDownContainer = styled.div`
  padding: 10px 20px;
  overflow: scroll;
  height: 360px;
  box-sizing: border-box;
  @media (max-width: 980px) {
    a {
      p {
        padding: 10px 0px 0px 0px;
      }
    }
  }
`;

const MidItemLink = styled.a`
  text-decoration: none;
`;

const LinkText = styled.p`
  color: #54536c;
  font-family: "Lato";
  font-size: 15px;
  font-weight: normal;
  margin: 0;
`;

const ProductContainer = styled.div`
  overflow: scroll;
  height: 360px;
  box-sizing: border-box;
  padding: 10px 20px;
  ${(props) => props.isHomePage && `column-count: 2;`}
  a {
    p {
      margin: 0px;
      padding: 20px 0px 0px 0px;
    }
  }
  @media (min-width: 981px) {
    column-count: 3;
    padding: 10px 0px;
  }
  @media (max-width: 980px) {
    a {
      p {
        padding: 10px 0px 0px 0px;
      }
    }
  }
`;

const SocialProductContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 15px 0px;
`;

const CreateListItem = styled.div`
  display: flex;
  align-items: center;
  img {
    margin-right: 10px;
  }
`;

const apiUrl = config["APIURIS"][config["APIURIS"]["current"]];
// const apiUrl = config["APIURIS"]["demo"];
const authUrl = config["AUTHURLS"][config["AUTHURLS"]["current"]];
// const authUrl = config["AUTHURLS"]["demo"];
const appUrl = config["APPURLS"][config["APPURLS"]["current"]];

const BASE_PATH = process.env.BASE_PATH;
const LinkUrl = "https://www.picmaker.com";

const productsMap = [
  {
    title: <LinkText>Certificate Maker</LinkText>,
    link: `${LinkUrl}/certificate-maker`,
  },
  {
    title: <LinkText>Blog Banner Maker</LinkText>,
    link: `${LinkUrl}/free-blog-banner-maker`,
  },
  {
    title: <LinkText>Poster Maker</LinkText>,
    link: `${LinkUrl}/poster-maker`,
  },
  {
    title: <LinkText>Youtube Banner Maker</LinkText>,
    link: `${LinkUrl}/youtube-banner-maker`,
  },
  {
    title: <LinkText>Youtube Thumbnail Maker</LinkText>,
    link: `${LinkUrl}/youtube-thumbnail-maker`,
  },
  {
    title: <LinkText>Facebook Ad Creator</LinkText>,
    link: `${LinkUrl}/facebook-ad-creator`,
  },
  {
    title: <LinkText>Facebook Post Maker</LinkText>,
    link: `${LinkUrl}/facebook-post-maker`,
  },
  {
    title: <LinkText>Instagram Story Maker</LinkText>,
    link: `${LinkUrl}/instagram-story-maker`,
  },
  {
    title: <LinkText>Instagram Post Maker</LinkText>,
    link: `${LinkUrl}/instagram-post-maker`,
  },
  {
    title: <LinkText>LinkedIn Banner Maker</LinkText>,
    link: `${LinkUrl}/linkedin-banner-maker`,
  },
  {
    title: <LinkText>Meme Generator</LinkText>,
    link: `${LinkUrl}/meme-generator`,
  },
  {
    title: <LinkText>Invoice Maker</LinkText>,
    link: `${LinkUrl}/invoice-maker`,
  },
  {
    title: <LinkText>Brochure Maker</LinkText>,
    link: `${LinkUrl}/brochure-maker`,
  },
  {
    title: <LinkText>Email Header</LinkText>,
    link: `${LinkUrl}/email-header`,
  },
  {
    title: <LinkText>Stock Images</LinkText>,
    link: `${LinkUrl}/features/stock-images`,
  },
  {
    title: <LinkText>Sticker Maker</LinkText>,
    link: `${LinkUrl}/sticker-maker`,
  },
  {
    title: <LinkText>Invitation Maker</LinkText>,
    link: `${LinkUrl}/invitation-maker`,
  },
  {
    title: <LinkText>Blog Graphics</LinkText>,
    link: `${LinkUrl}/free-blog-graphics`,
  },
  {
    title: <LinkText>Photo Editor</LinkText>,
    link: `${LinkUrl}/photo-editor`,
  },
  {
    title: <LinkText>Collage Maker</LinkText>,
    link: `${LinkUrl}/collage-maker`,
  },
  {
    title: <LinkText>Flyer Maker</LinkText>,
    link: `${LinkUrl}/flyer-maker`,
  },
  {
    title: <LinkText>Logo Maker</LinkText>,
    link: `${LinkUrl}/logo-maker`,
  },
  {
    title: <LinkText>Twitter Post Maker</LinkText>,
    link: `${LinkUrl}/twitter-post-maker`,
  },
  {
    title: <LinkText>Background Remover</LinkText>,
    link: `${LinkUrl}/background-remover`,
  },
  {
    title: <LinkText>Label Maker</LinkText>,
    link: `${LinkUrl}/label-maker`,
  },
];

const socialMap = [
  {
    title: <LinkText>Social Media Management Tool</LinkText>,
    link: `${LinkUrl}/social-media-management-tool`,
  },
  {
    title: <LinkText>Instagram Post Scheduler</LinkText>,
    link: `${LinkUrl}/schedule/instagram-post`,
  },
  {
    title: <LinkText>Facebook Post Scheduler</LinkText>,
    link: `${LinkUrl}/schedule/facebook-post`,
  },
  {
    title: <LinkText>Linkedin Post Scheduler</LinkText>,
    link: `${LinkUrl}/schedule/linkedin-post`,
  },
  {
    title: <LinkText>Pinterest Pin Scheduler</LinkText>,
    link: `${LinkUrl}/schedule/pinterest-pin`,
  },
];

export default function Header({ trackId }) {
  const router = useRouter();
  const [showHelloBar, setShowHelloBar] = useState(true);
  const [showSearch, setShowSearch] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [createMenu, setCreateMenu] = useState([]);
  const [trackIdList, setTrackIdList] = useState([]);
  const [menuClick, setMenuClick] = useState(false);
  const { isMobileWidth, size } = useCheckIsMobile();
  const [currentAccordion, setCurrentAccordion] = useState(null);
  const [bodyHeight, setBodyHeight] = useState(0);
  const [accordionData, setAccordionData] = useState([
    {
      title: "Picmaker Social",
      content: [...socialMap],
    },
    {
      title: "Products",
      content: [...productsMap],
    },
  ]);
  const createRef = useRef(null);
  const productsRef = useRef(null);

  const refs = [createRef, productsRef];

  useEffect(() => {
    if (createMenu.length === 0) {
      getCreateMenuData();
    }
  }, []);

  async function getCreateMenuData() {
    const { data } = await apiRequest("post", `${apiUrl}dynamic/`);
    const createMenuData =
      !!data["data"] && !!data["data"]["design_category"]
        ? data["data"]["design_category"]
        : [];
    const trackId =
      !!data["data"] && data["data"]["trackid"] ? data["data"]["trackid"] : "";
    getCreateAccordionData(createMenuData);
    setTrackIdList(trackId);
    setCreateMenu(createMenuData);
  }

  function getCreateAccordionData(data) {
    const temp = data.map((category) => {
      return {
        title: (
          <CreateListItem>
            <img
              src={`${appUrl}static/imagesizes/${category["_source"].img}`}
              alt={category["_source"].name}
              title={category["_source"].name}
              height="30px"
              width="30px"
            />
            <LinkText>{category["_source"].name}</LinkText>
          </CreateListItem>
        ),
        link: `/templates/${category["_source"].page_url}`,
      };
    });
    setAccordionData([
      { title: "Create", content: [...temp] },
      ...accordionData,
    ]);
  }

  function handleLeftClick(event) {
    const element = event.target.nextSibling.nextSibling;
    let offsetHeight = element.offsetWidth;
    element.scrollLeft -= offsetHeight;
  }

  function handleRightClick(event) {
    const element = event.target.nextSibling;
    let offsetHeight = element.offsetWidth;
    element.scrollLeft += offsetHeight;
  }

  function handleScroll(event) {
    const element = event.target;
    let topVal = element.scrollLeft;
    let totalHeight = element.scrollWidth;
    let offsetHeight = element.offsetWidth;

    if (offsetHeight > 425) {
      if (topVal + offsetHeight >= totalHeight) {
        element.parentElement.children[1].style.display = "none";
      } else if (topVal === 0) {
        element.parentElement.children[0].style.display = "none";
        element.parentElement.children[1].style.display = "block";
      } else if (topVal > 0) {
        element.parentElement.children[0].style.display = "block";
        element.parentElement.children[1].style.display = "block";
      }
    }
  }

  function handleClick() {
    setShowSearch(true);
  }

  function handleMenuClick() {
    setMenuClick(!menuClick);
    setShowMenu(!showMenu);
  }

  function getTrackId() {
    if (
      createMenu &&
      trackIdList &&
      createMenu.length > 0 &&
      trackIdList.length > 0
    ) {
      let category = [];
      if (router.pathname === "/" || router.pathname === "/search") {
        const isSearchPage = router.pathname === "/search";
        const track = trackIdList.filter(
          (trackId) =>
            trackId["_source"].name ===
            (isSearchPage ? "Search" : "Landing Page")
        );
        return track.length > 0 ? track[0]["_source"]["trackid"] : "";
      }

      if (
        router.query &&
        Object.keys(router.query).length > 0 &&
        router.query.id
      ) {
        category = createMenu.filter(
          (menu) => menu["_source"].page_url === router.query.id
        );
      }
      if (category.length > 0) {
        const track = trackIdList.filter(
          (trackId) =>
            trackId["_source"].category === category[0]["_source"].category
        );
        return track.length > 0 ? track[0]["_source"]["trackid"] : "";
      }
    }
    return "";
  }

  return (
    <>
    {showHelloBar ? <HelloBar close={() => {
      setShowHelloBar(false)
    }} /> : null}
    <AppHeader showHelloBar={showHelloBar}>
      <NavBar>
        <LogoContainer>
          <Link href="https://www.picmaker.com" passHref>
            <a rel="noopener">
              <img
                src={`${BASE_PATH}/images/Logo.svg`}
                alt="picmaker-logo"
                width={"100px"}
                height={"65px"}
                rel="preload"
                title="picmaker-logo"
              />
            </a>
          </Link>
        </LogoContainer>
        <HeaderTagContainer showSearch={showSearch}>
          {!(router.pathname === "/") && (
            <SearchBar urlDetails={""} setShowSearch={setShowSearch} />
          )}
        </HeaderTagContainer>
        <HeaderResContainer>
          {!(router.pathname === "/") && (
            <SearchBarIconContainer
              onClick={handleClick}
              id="header-search-icon"
            >
              <img
                src={`${BASE_PATH}/images/icon-search.svg`}
                width="18px"
                height="18px"
                alt="search_icon"
                title="search_icon"
              />
            </SearchBarIconContainer>
          )}
          <MenuBarContainer
            page={router.pathname}
            onClick={handleMenuClick}
            open={showMenu}
          >
            <MenuBar />
            <MenuBar />
            <MenuBar />
          </MenuBarContainer>
        </HeaderResContainer>
        {!(router.pathname === "/") && (
          <RoundedMenuContainer onClick={handleMenuClick} active={menuClick}>
            <RoundedMenu />
            <RoundedMenu />
            <RoundedMenu />
          </RoundedMenuContainer>
        )}
        <HeaderTagRightContainer page={router.pathname} open={showMenu}>
          {isMobileWidth && (
            <>
              <Accordion
                accordionContent={accordionData}
                refs={refs}
                currentAccordion={currentAccordion}
                setCurrentAccordion={setCurrentAccordion}
                setBodyHeight={setBodyHeight}
                bodyHeight={bodyHeight}
                isHeader={true}
              />
            </>
          )}
          {!isMobileWidth && (
            <ProductTagContainer>
              <CreateTag className="product-tag">
                <HeaderLinkTag>
                Picmaker Social
                <span className="coming-soon">New</span>
              </HeaderLinkTag>
                <img
                  src={`${BASE_PATH}/images/icon-down-arrow.svg`}
                  alt="down-arrow"
                  width="10px"
                  height="12px"
                  rel="preload"
                />
              </CreateTag>
              <SocialDropDownContainer
                isHomePage={router.pathname === "/"}
                className="product-drop-down"
              >
                <SocialProductContainer isHomePage={router.pathname === "/"}>
                  {socialMap.map((product, index) => (
                    <Link key={index} href={product.link} passHref>
                      <MidItemLink>{product.title}</MidItemLink>
                    </Link>
                  ))}
                </SocialProductContainer>
              </SocialDropDownContainer>
            </ProductTagContainer>
          )}
          {!(router.pathname === "/") && !isMobileWidth && (
            <CreateTagContainer>
              <CreateTag className="create-tag">
                <HeaderTagContent>Create</HeaderTagContent>
                <img
                  src={`${BASE_PATH}/images/icon-down-arrow.svg`}
                  alt="down-arrow"
                  width="12px"
                  height="12px"
                  rel="preload"
                />
              </CreateTag>
              <CreateDropDownContainer className="create-drop-down">
                {createMenu.length <= 0 ? (
                  <ContentLoader />
                ) : !isMobileWidth && size[0] < 980 ? (
                  <MidDropDownContainer>
                    {createMenu.map((category, index) => (
                      <Link
                        key={index}
                        href={`/${category["_source"].page_url}`}
                        passHref
                      >
                        <MidItemLink>
                          <LinkText onClick={() => window.scrollTo(0, 0)}>
                            {category["_source"].name}
                          </LinkText>
                        </MidItemLink>
                      </Link>
                    ))}
                  </MidDropDownContainer>
                ) : (
                  <TemplateContainer>
                    <TemplateListConatiner>
                      <LeftSliderIcon
                        url={`${appUrl}static/icons/slide-left-arrow.svg`}
                        onClick={handleLeftClick}
                      />
                      <RightSliderIcon
                        url={`${appUrl}static/icons/slide-right-arrow.svg`}
                        onClick={handleRightClick}
                      />
                      <TemplateListWrapper onScroll={handleScroll}>
                        {createMenu.map((category, index) => (
                          <TemplateWrapper key={index}>
                            <Link
                              href={`/${category["_source"].page_url}`}
                              passHref
                            >
                              <Template
                                width={category["_source"].width}
                                height={category["_source"].height}
                                color={category["_source"].background}
                                rel="noopener"
                                onClick={() => window.scrollTo(0, 0)}
                              >
                                <img
                                  src={`${appUrl}static/imagesizes/${category["_source"].img}`}
                                  alt="logo-img"
                                  width={
                                    category["_source"].name
                                      .toLowerCase()
                                      .includes("facebook")
                                      ? "30px"
                                      : "40px"
                                  }
                                  height={
                                    category["_source"].name
                                      .toLowerCase()
                                      .includes("facebook")
                                      ? "30px"
                                      : "40px"
                                  }
                                />
                              </Template>
                            </Link>
                            <TemplateTitle>
                              {category["_source"].name}
                            </TemplateTitle>
                          </TemplateWrapper>
                        ))}
                      </TemplateListWrapper>
                    </TemplateListConatiner>
                  </TemplateContainer>
                )}
              </CreateDropDownContainer>
            </CreateTagContainer>
          )}
          {!isMobileWidth && (
            <ProductTagContainer>
              <CreateTag className="product-tag">
                <HeaderTagContent>Products</HeaderTagContent>
                <img
                  src={`${BASE_PATH}/images/icon-down-arrow.svg`}
                  alt="down-arrow"
                  width="10px"
                  height="12px"
                  rel="preload"
                />
              </CreateTag>
              <ProductDropDownContainer
                isHomePage={router.pathname === "/"}
                className="product-drop-down"
              >
                <ProductContainer isHomePage={router.pathname === "/"}>
                  {productsMap.map((product, index) => (
                    <Link key={index} href={product.link} passHref>
                      <MidItemLink>{product.title}</MidItemLink>
                    </Link>
                  ))}
                </ProductContainer>
              </ProductDropDownContainer>
            </ProductTagContainer>
          )}
          <HeaderTag>
            <HeaderLinkTag
              href={`${LinkUrl}/features`}
              target="_blank"
              rel="noopener"
            >
              Features
            </HeaderLinkTag>
          </HeaderTag>
          <HeaderTag>
            <HeaderLinkTag
              href={`${apiUrl}pricing`}
              target="_blank"
              rel="noopener"
            >
              Pricing
              <span className="coming-soon">New</span>
            </HeaderLinkTag>
          </HeaderTag>
          <HeaderTag>
            <HeaderLinkTag
              href={`${authUrl}login/picmaker?trackId=${
                trackId ? trackId : getTrackId()
              }`}
              target="_blank"
              rel="noopener"
            >
              Login
            </HeaderLinkTag>
          </HeaderTag>
          <SmallButton
            href={`${authUrl}register/picmaker?trackId=${
              trackId ? trackId : getTrackId()
            }`}
            target="_blank"
            rel="noopener"
          >
            Sign Up
          </SmallButton>
        </HeaderTagRightContainer>
      </NavBar>
    </AppHeader>
    </>
  );
}
